import { Trans, useTranslation } from "react-i18next";
import aluminuim from "../assets/images/aluminium.jpg";

const AnticipateSection = ({ language }: { language: string }) => {
  const { t } = useTranslation();

  return (
    <section className="mt-24">
      <div className="max-w-screen-xl flex flex-col items-center gap-x-8 lg:flex-row lg:mx-4 2xl:mx-auto">
        <div className="max-w-[90%]">
          <div className="h-80 lg:w-[593px]">
            <img
              src={aluminuim}
              alt="aluminuim"
              className="h-full w-full object-cover object-top"
            />
          </div>
        </div>
        <div className="max-w-[90%] mt-11 lg:mt-0 xl:max-w-2xl">
          <span>{t("AUSBLICK")}</span>
          <h2 className="text-4xl leading-10 font-black font-Roboto mt-2">
            <Trans>Heute schon weiter denken</Trans>
          </h2>
          <div className="font-Roboto mt-4 mb-8">
            <Trans>
							Wir planen den Einsatz von nachhaltigerem Aluminium stetig zu
							erweitern. Neben REDUXA wollen wir zukünftig auch CIRCAL
							einsetzen. Dieses soll zu mindestens 75% aus recyceltem Aluminium
							bestehen und benötigt dabei nur 5% der Energie*, die bei der
							Herstellung von Primär-Aluminium benötigt wird. Auf diese Weise
							können wir zusätzlich den Ressourcen-Verbrauch minimieren und
							einen Beitrag zur Kreislaufwirtschaft leisten.
            </Trans>
          </div>
          <a
            href={
              language === "de"
                ? "https://www.hydro.com/de-DE/aluminium/uber-aluminium/der-lebenszyklus-von-aluminium/"
                : "https://www.hydro.com/en-DE/aluminium/about-aluminium/aluminium-life-cycle/"
            }
            className="underline cursor-pointer font-Roboto text-xs leading-6 max-w-[90%]"
            target="_blank"
            rel="noreferrer"
          >
            {language === "de"
              ? "https://www.hydro.com/de-DE/aluminium/uber-aluminium/der-lebenszyklus-von-aluminium/"
              : "https://www.hydro.com/en-DE/aluminium/about-aluminium/aluminium-life-cycle/"}
          </a>
        </div>
      </div>
    </section>
  );
};

export default AnticipateSection;
